
<div class="card">
    <div class="card-header">
        PAYMENT DETAILS
      <a *ngIf="enableEdit" (click)="editPayment()" class="editIcon">
        <!-- <img src="/images/new_ui/catalogues-edit.png" alt="Edit Delivery Address"> -->
        <span class="basic-icon edit-icon"></span>
      </a>
    </div>
    <div class="card-body">
        <div class="detail">
            <span>Amount: {{paymentSummary.totalAmount}} </span>
            <br/>
            <span>Charged to: {{paymentSummary.paymentMethod}}</span>
<!--            <span *ngIf="paymentSummary.paymentMethod == 'DIGITAL WALLET'">CARD: {{paymentSummary.nameOnCard}}</span>-->
            <span *ngIf="paymentSummary.paymentMethod == 'DIGITAL WALLET'">CARD: {{(selectedDigitalWallet$|async)?.text}}</span>
          <br />
            <span>PO number: {{paymentSummary.poReference}}</span>
        </div>
    </div>
  </div>
